import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import msal, { getUser, loginRequest, clearInteractionProgress } from 'lib/msal';
import { appInsights, getEnhancedLogLevel } from 'lib/appInsights';
import * as microsoftTeams from "@microsoft/teams-js";
import { getMe } from 'actions/user';
import { Button, translate, setActiveLanguage, getActiveLanguage, Spinner } from '@haldor/ui';
import { withRouter } from 'react-router-dom';
import sniffer from 'sniffer';

var LandingPage = /*#__PURE__*/function (_Component) {
  _inherits(LandingPage, _Component);

  var _super = _createSuper(LandingPage);

  function LandingPage(props) {
    var _this;

    _classCallCheck(this, LandingPage);

    _this = _super.call(this, props); // Initialize the state

    _defineProperty(_assertThisInitialized(_this), "login", function () {
      try {
        if (microsoftTeams.app.isInitialized()) {
          microsoftTeams.app.getContext().then(function (context) {
            microsoftTeams.authentication.getAuthToken().then(function (token) {
              if (_this.props.onLogin != null) {
                _this.props.onLogin(token);
              }
            });
          });
        } else {
          var request = {
            redirectUri: window.location.origin + '/authenticate/callback?platform=browser',
            scopes: ["openid", "profile", "offline_access", "user.read"],
            state: JSON.stringify({
              url: window.location.pathname + window.location.search
            })
          };
          clearInteractionProgress();
          msal.loginRedirect(request);
        }
      } catch (error) {
        appInsights.trackTrace({
          message: 'EDU016d | Login failed, unexpected error'
        }, {
          error: JSON.stringify(error),
          logLevel: getEnhancedLogLevel()
        });
        console.error('fail popup error LandingPage:', error);
      }
    });

    _this.state = {
      loading: true,
      redirect: '/haldor-tab',
      lang: null
    };
    return _this;
  }

  _createClass(LandingPage, [{
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("Login Page", window.location);
                this.setState({
                  loading: false
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      if (this.props.currentUser == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "login-content"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            backgroundColor: '#FFF',
            boxShadow: '0 5px 15px 0 rgb(0 0 0 / 5%)',
            borderRadius: '3px',
            padding: '1.4rem 3rem',
            marginBottom: '3rem',
            textAlign: 'left'
          }
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
          style: {
            minHeight: '8rem',
            marginTop: '-6rem'
          },
          src: "/dist/svg/haldor_logo_rgb.svg"
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '-6rem'
          }
        }, this.props.translate('In order to start using Haldor you need to login with your Microsoft account. This gives us the permission to launch Haldor so you can get started.'), /*#__PURE__*/React.createElement(Button, {
          style: {
            display: 'block',
            marginTop: '1.5rem'
          },
          type: "secondary",
          onClick: this.login
        }, this.props.translate('log-in')))));
      }

      return /*#__PURE__*/React.createElement("div", null);
    }
  }]);

  return LandingPage;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages,
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  getMe: getMe
})(LandingPage);